import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Check, XCircle } from 'react-feather';
import theme from 'constants/theme';
import FormatContent from 'modules/Course/Unit/components/FormatContent';
import FormatContentArrow from 'modules/Course/Unit/components/FormatContentArrow';
import { Alert, UncontrolledTooltip } from 'reactstrap';
import stylesCourse from 'styles/Course.module.scss';
import { parseHtml } from 'helpers';
import { useViewMode } from 'hooks';
import {
  RESULT_STATUS,
  SHOW_ANSWERS,
  UNIT_STATUS,
  USER_ROLES,
} from 'constants/constants';
import { useUnit } from 'hooks/units';
const DragDropResult = ({
  result,
  showYourAnswer,
  showCorrectIcon,
  isModal,
}) => {
  const viewMode = useViewMode();
  const unitSelected = useUnit();
  const config = unitSelected?.config;

  const showCorrect =
    config?.completion?.showCorrect === SHOW_ANSWERS.ALWAYS &&
    result?.status !== RESULT_STATUS.NOTASSIGNED
      ? true
      : config?.completion?.showCorrect === SHOW_ANSWERS.PASSED &&
        unitSelected?.status === UNIT_STATUS.COMPLETED &&
        result?.status !== RESULT_STATUS.NOTASSIGNED
      ? true
      : false;
  const iconsShow = unitSelected?.config?.completion?.labels;

  const listResult = result?.resultAnswers.map((item) => item?.content);
  const listCorrect = result?.resultAnswers;
  const listResult1 = result?.data.map((item) => item?.content);
  const listCorrect1 = result?.data.map((item) => item?.correct);
  const CorrectLebal = result?.resultAnswers.map(
    (item, index) => item?.correct,
  );

  const listAnswerCheck = result?.resultAnswers.map(
    (item, index) =>
      iconsShow && (
        <>
          {item?.correct ? (
            <>
              <Check color={theme.success} className="ml-2" id="success" />
              <UncontrolledTooltip placement="right" target="success">
                This was the correct answer
              </UncontrolledTooltip>
            </>
          ) : (
            <>
              <XCircle color={theme.danger} className="ml-2" id="failed" />
              <UncontrolledTooltip placement="right" target="failed">
                This was the wrong answer
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
  );
  const listcheckcorrectIcon = result?.data?.map((item, index) => (
    <React.Fragment key={index}>
      {iconsShow && (
        <React.Fragment>
          {item?.correct && (
            <>
              <Check
                color={theme.success}
                className="ml-2"
                id={`success-${index}`}
              />
              <UncontrolledTooltip
                placement="right"
                target={`success-${index}`}
              >
                This was the correct answer
              </UncontrolledTooltip>
            </>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  ));

  const [listHeight, setListHeight] = useState({
    correctQusList: [],
    correctAnsList: [],
    correctCommonHeight: [],

    yourQusList: [],
    yourAnsList: [],
    yourCommonHeight: [],

    quesList: [],
    ansList: [],
    quesAnsCommonHeight: [],
  });

  const correctQusElementRef = useRef(null);
  const correctAnsElementRef = useRef(null);
  const yourQusElementRef = useRef(null);
  const yourAnsElementRef = useRef(null);
  const QusElementRef = useRef(null);
  const AnsElementRef = useRef(null);

  // get quiz element height
  useEffect(() => {
    if (!QusElementRef?.current) return null;
    const calculateHeights = () => {
      const newArray = Array.from(QusElementRef.current.children).map(
        (item, index) => item.clientHeight,
      );
      setListHeight((preVal) => ({
        ...preVal,
        quesList: [...newArray],
      }));
    };
    const images = document.querySelectorAll('img');
    let loadedImagesCount = 0;

    const handleImageLoad = () => {
      loadedImagesCount += 1;
      if (loadedImagesCount === images.length) {
        calculateHeights();
      }
    };
    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [QusElementRef?.current]);

  // get ans element height
  useEffect(() => {
    if (!AnsElementRef?.current) return null;
    const calculateHeights = () => {
      const newArray = Array.from(AnsElementRef.current.children).map(
        (item, index) => item.clientHeight,
      );

      setListHeight((preVal) => ({
        ...preVal,
        ansList: [...newArray],
      }));
    };
    const images = document.querySelectorAll('img');
    let loadedImagesCount = 0;

    const handleImageLoad = () => {
      loadedImagesCount += 1;
      if (loadedImagesCount === images.length) {
        calculateHeights();
      }
    };
    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [AnsElementRef?.current]);

  //  get common height from quiz{quiz, ans}
  useEffect(() => {
    if (listHeight.quesList.length === 0 && listHeight.ansList.length === 0)
      return null;
    const filterHeight = listHeight.ansList.map((item, index) =>
      listHeight.quesList[index] >= item ? listHeight.quesList[index] : item,
    );
    setListHeight((preVal) => ({
      ...preVal,
      quesAnsCommonHeight: [...filterHeight],
    }));
  }, [listHeight.ansList, listHeight.quesList]);

  // get corect quiz element height
  useEffect(() => {
    if (!correctQusElementRef?.current) return null;
    const calculateHeights = () => {
      const newArray = Array.from(correctQusElementRef.current.children).map(
        (item, index) => item.clientHeight,
      );
      setListHeight((preVal) => ({
        ...preVal,
        correctQusList: [...newArray],
      }));
    };
    const images = document.querySelectorAll('img');
    let loadedImagesCount = 0;

    const handleImageLoad = () => {
      loadedImagesCount += 1;
      if (loadedImagesCount === images.length) {
        calculateHeights();
      }
    };
    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [correctQusElementRef?.current]);

  //  get correct ans element height
  useEffect(() => {
    if (!correctAnsElementRef?.current) return null;
    const calculateHeights = () => {
      const newArray = Array.from(correctAnsElementRef.current.children).map(
        (item, index) => item.clientHeight,
      );

      setListHeight((preVal) => ({
        ...preVal,
        correctAnsList: [...newArray],
      }));
    };
    const images = document.querySelectorAll('img');
    let loadedImagesCount = 0;

    const handleImageLoad = () => {
      loadedImagesCount += 1;
      if (loadedImagesCount === images.length) {
        calculateHeights();
      }
    };
    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [correctAnsElementRef?.current]);

  //  get common height from correct{quiz, ans}
  useEffect(() => {
    if (
      listHeight.correctAnsList.length === 0 &&
      listHeight.correctQusList.length === 0
    )
      return null;
    const filterHeight = listHeight.correctAnsList.map((item, index) =>
      listHeight.correctQusList[index] >= item
        ? listHeight.correctQusList[index]
        : item,
    );
    setListHeight((preVal) => ({
      ...preVal,
      correctCommonHeight: [...filterHeight],
    }));
  }, [listHeight.correctAnsList, listHeight.correctQusList]);

  // get your quiz element height
  useEffect(() => {
    if (!yourQusElementRef?.current) return null;
    const calculateHeights = () => {
      const newArray = Array.from(yourQusElementRef.current.children).map(
        (item, index) => item.clientHeight,
      );
      setListHeight((preVal) => ({
        ...preVal,
        yourQusList: [...newArray],
      }));
    };
    const images = document.querySelectorAll('img');
    let loadedImagesCount = 0;

    const handleImageLoad = () => {
      loadedImagesCount += 1;
      if (loadedImagesCount === images.length) {
        calculateHeights();
      }
    };
    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [yourQusElementRef?.current]);

  // get your ans element height
  useEffect(() => {
    if (!yourAnsElementRef?.current) return null;
    const calculateHeights = () => {
      const newArray = Array.from(yourAnsElementRef.current.children).map(
        (item, index) => item.clientHeight,
      );
      setListHeight((preVal) => ({
        ...preVal,
        yourAnsList: [...newArray],
      }));
    };
    const images = document.querySelectorAll('img');
    let loadedImagesCount = 0;

    const handleImageLoad = () => {
      loadedImagesCount += 1;
      if (loadedImagesCount === images.length) {
        calculateHeights();
      }
    };
    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [yourAnsElementRef?.current]);

  // get common height from your answer {quiz, ans}
  useEffect(() => {
    if (
      listHeight.yourAnsList.length === 0 &&
      listHeight.yourQusList.length === 0
    )
      return null;
    const filterHeight = listHeight.yourAnsList.map((item, index) =>
      listHeight.yourQusList[index] >= item
        ? listHeight.yourQusList[index]
        : item,
    );
    setListHeight((preVal) => ({
      ...preVal,
      yourCommonHeight: [...filterHeight],
    }));
  }, [listHeight.yourQusList, listHeight.yourAnsList]);

  const indexLength = result?.resultAnswers?.length;
  const indexLengthCorrect = result?.data?.length;
  return (
    <div>
      {(viewMode !== USER_ROLES.LEARNER || showCorrect) && (
        <div className="freetext-correct-ans">
          <div className={`d-flex mb-1 `}>
            <div ref={QusElementRef}>
              <FormatContent
                list={listResult1}
                commonHeight={listHeight.quesAnsCommonHeight}
              />
            </div>
            <div>
              <FormatContentArrow
                index={indexLengthCorrect}
                commonHeight={listHeight.quesAnsCommonHeight}
              />
            </div>
            <div ref={AnsElementRef}>
              <FormatContent
                list={listCorrect1}
                commonHeight={listHeight.quesAnsCommonHeight}
              />
            </div>
          </div>
          <span className={`view-page-title`}>Correct Answer:</span>
          <Alert className={`mt-05  show`}>
            <div className="d-flex">
              <div className="col">
                <div className="row" style={{ flexWrap: 'nowrap' }}>
                  <div ref={correctQusElementRef}>
                    <FormatContent
                      list={listResult1}
                      commonHeight={listHeight.correctCommonHeight}
                      isLabel={false}
                      isCorrectLabel={false}
                    />
                  </div>
                  <div>
                    <FormatContentArrow
                      index={indexLengthCorrect}
                      commonHeight={listHeight.correctCommonHeight}
                    />
                  </div>
                  <div ref={correctAnsElementRef}>
                    <FormatContent
                      list={listCorrect1}
                      commonHeight={listHeight.correctCommonHeight}
                      showCorrect={showCorrect}
                      iconsShow={iconsShow}
                      isLabel={true}
                      isCorrectLabel={false}
                    />
                  </div>
                </div>
              </div>
              {/* <div>
                <FormatContentArrow
                  list={listcheckcorrectIcon}
                  commonHeight={listHeight.correctCommonHeight}
                />
              </div> */}
            </div>
          </Alert>
        </div>
      )}
      {showYourAnswer && (
        <div className="freetext-correct-ans">
          <span className={`view-page-title `}>
            {viewMode === USER_ROLES.LEARNER ? 'Your Answer' : 'Learner Answer'}
            :{' '}
          </span>
          <Alert className={`mt-05 show `}>
            <div className="d-flex ">
              <div className="col">
                <div className="row" style={{ flexWrap: 'nowrap' }}>
                  <div ref={yourQusElementRef}>
                    <FormatContent
                      list={listResult}
                      commonHeight={listHeight.yourCommonHeight}
                      isCorrectLabel={false}
                      isLabel={false}
                    />
                  </div>
                  <div>
                    <FormatContentArrow
                      index={indexLength}
                      commonHeight={listHeight.yourCommonHeight}
                    />
                  </div>
                  <div ref={yourAnsElementRef}>
                    <FormatContent
                      list={listCorrect}
                      isYourans={true}
                      commonHeight={listHeight.yourCommonHeight}
                      CorrectLebal={CorrectLebal}
                      showCorrect={showCorrect}
                      iconsShow={iconsShow}
                      isCorrectLabel={true}
                      isLabel={false}
                    />
                  </div>
                </div>
              </div>
              <div>
                {/* {showCorrectIcon && (
                  <div>
                    <FormatContentArrow
                      list={listAnswerCheck}
                      commonHeight={listHeight.yourCommonHeight}
                    />
                  </div>
                )} */}
              </div>
            </div>
          </Alert>
        </div>
      )}
    </div>
  );
};

DragDropResult.propTypes = {
  result: PropTypes.object.isRequired,
};

export default DragDropResult;
